"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var inputUtils_1 = require("../../core/inputUtils");
var getName = function (text) {
    if (text) {
        return text.toLowerCase().replace(' ', '-');
    }
    return undefined;
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'skin', 'styleProperties'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, skin = _a.skin;
    return (__assign(__assign({ skin: skin === 'ResponsiveTextInputSkin'
            ? 'ResponsiveTextInputSkin'
            : 'AppsTextInputSkin', value: compData.value || '', inputType: compData.textType, label: compData.label, name: getName(compData.label || compData.placeholder || compProps.placeholder), placeholder: compData.placeholder || compProps.placeholder, readOnly: compProps.readOnly || false, required: compProps.required, autoComplete: compData.textType !== 'password' && compProps.autoComplete, autoComplete_: compData.textType !== 'password' && compProps.autoComplete ? 'on' : null, isDisabled: compProps.isDisabled || false, pattern: compData.pattern, maxLength: compData.maxLength }, (compData.textType === 'number' && {
        min: compData.min,
        max: compData.max,
        step: compData.step,
    })), { prefix: compData.prefix, phoneFormat: compData.phoneFormat }));
});
var getTextPaddingCssVar = function (alignment, textPadding, withPrefix) {
    var padding = textPadding === undefined ? 3 : textPadding;
    var addedPrefix = withPrefix ? 50 : 0;
    switch (alignment) {
        case 'left':
            return "3px 3px 3px " + (padding + addedPrefix) + "px";
        case 'right':
            return "3px " + padding + "px 3px " + (3 + addedPrefix) + "px";
        default:
            return "3px " + (3 + addedPrefix) + "px 3px " + (3 + addedPrefix) + "px";
    }
};
var getDir = function (textAlignment, hasPhoneFormat) {
    if (hasPhoneFormat) {
        return 'ltr';
    }
    return textAlignment === 'right' ? 'rtl' : 'ltr';
};
exports.css = withCompInfo_1.withCompInfo([
    'compLayout',
    'compProps',
    'styleProperties',
    'isMobileView',
    'hasResponsiveLayout',
    'compData',
], function (_a, cssVars) {
    var compLayout = _a.compLayout, compProps = _a.compProps, styleProperties = _a.styleProperties, isMobileView = _a.isMobileView, hasResponsiveLayout = _a.hasResponsiveLayout, compData = _a.compData;
    var textAlignment = compProps.textAlignment, textPadding = compProps.textPadding, labelMargin = compProps.labelMargin;
    var prefix = compData.prefix, phoneFormat = compData.phoneFormat;
    var sharedProps = __assign(__assign({}, cssVars), { '--dir': getDir(textAlignment, !!phoneFormat), '--textAlign': textAlignment, '--textPadding': getTextPaddingCssVar(textAlignment, textPadding, !!prefix), '--labelPadding': inputUtils_1.getLabelPadding(compProps), '--requiredIndicationDisplay': inputUtils_1.getRequiredIndicationDisplay(styleProperties), '--labelMarginBottom': labelMargin + "px" });
    if (hasResponsiveLayout) {
        return sharedProps;
    }
    else {
        return __assign(__assign({}, sharedProps), { height: 'auto', '--inputHeight': inputUtils_1.getInputHeightInPx({
                compProps: compProps,
                compLayout: compLayout,
                isMobileView: isMobileView,
            }) });
    }
});
//# sourceMappingURL=TextInput.js.map